import { createContext } from 'react';
const managementContext = createContext();
export default managementContext;
